module.exports = __webpack_public_path__ + "static/media/Photo3.38623c15.jpg";